import axios from 'axios';

// Strip accidental surrounding quotes/whitespace: a quoted CI build-arg
// (REACT_APP_API_URL="https://...") would otherwise leave literal quotes in
// the value, producing an invalid baseURL that axios treats as relative.
const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9000';
const API_URL = RAW_API_URL.trim().replace(/^['"]+|['"]+$/g, '');

const apiClient = axios.create({
  baseURL: API_URL,
});

// === Intercettore per le Richieste in Uscita (CORRETTO) ===
apiClient.interceptors.request.use(
  (config) => {
    // --- LA CORREZIONE È QUI ---
    // Controlliamo se un header di autorizzazione è già stato impostato manualmente
    // (come facciamo nella chiamata a verify2FA).
    if (config.headers.Authorization) {
      // Se è già stato impostato, non facciamo nulla e lasciamo quello.
      return config;
    }

    // Se NESSUN header è stato impostato, allora procediamo ad aggiungere
    // quello standard dal localStorage.
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    
    if (process.env.NODE_ENV === 'development') {
      config.headers['ngrok-skip-browser-warning'] = 'true';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// === Intercettore per le Risposte in Entrata (il tuo codice è già corretto) ===
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
          window.location.href = '/login';
          return Promise.reject(error);
        }
        const refreshResponse = await axios.post(`${API_URL}/api/auth/refresh`, {}, {
            headers: { Authorization: `Bearer ${refreshToken}` }
        });
        const newAccessToken = refreshResponse.data.access_token;
        localStorage.setItem('access_token', newAccessToken);
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
